import React, { useRef } from 'react';
import { Box } from '@curves/ui-base';
import useEChart from '@Util/hook/useEChart';
import { LINE_SINGLE, LINE_SINGLE_AREA_COLOR } from '@Local/Dashboard/dashboard.config';
import { monthFormatter } from '@Local/Dashboard/dashboard.util';
import { graphic } from 'echarts';

/********* 會員管道來源 *********/
const MeasureTrendLineChart = React.forwardRef((props, ref) => {
    const chartDomRef = useRef(null);
    const { sourceData } = props;

    const { title = '', subtitle = '', xAxis = [], data = [] } = sourceData;

    const isLoading = data.length === 0;

    const option = {
        title: {
            left: 24,
            top: 20,
            text: title,
            textStyle: {
                fontSize: 20,
                fontWeight: 600,
                color: '#1F2937',
            },
            subtext: subtitle,
            subtextStyle: {
                fontSize: 14,
                color: '#64748B',
                padding: [8, 0, 0, 0],
            },
        },

        grid: {
            left: 60,
            right: 40,
            top: 80,
            bottom: 60,
        },

        tooltip: {
            trigger: 'axis',
            alwaysShowContent: false,
            triggerOn: 'click',
        },

        xAxis: [
            {
                type: 'category',
                data: xAxis,
                axisLabel: {
                    fontSize: 12,
                    color: '#666',
                    margin: 8,
                    // interval: 0,
                    // rotate: -30,
                    formatter: monthFormatter,
                },
                axisTick: { show: false },
                axisLine: { show: true },
                splitLine: { show: false },
            },
        ],

        yAxis: {
            type: 'value',
            scale: true,
        },

        color: LINE_SINGLE,
        series: [
            {
                type: 'line',
                name: title,
                data: data[0],
                symbolSize: 8,
                areaStyle: {
                    opacity: 0.5,
                    color: new graphic.LinearGradient(0, 0, 0, 1, [
                        { offset: 0, color: LINE_SINGLE_AREA_COLOR[0] },
                        { offset: 1, color: LINE_SINGLE_AREA_COLOR[1] },
                    ]),
                },
            },
        ],
        dataZoom: [
            {
                disabled: xAxis.length <= 7,
                type: 'inside',
                xAxisIndex: 0,
                filterMode: 'none',
                zoomLock: true,
                zoomOnMouseWheel: false,
                moveOnMouseMove: true,
                moveOnMouseWheel: true,
                preventDefaultMouseMove: true,
                start: xAxis.length <= 7 ? 0 : xAxis.length <= 14 ? 40 : 60,
                end: 100,
            },
            {
                show: xAxis.length > 7,
                type: 'slider',
                height: 8,
                bottom: 8,
                showDataShadow: false,
                showDetail: false,
                handleSize: 20,
                handleStyle: {
                    color: 'rgba(91,15,115,0.2)',
                    borderWidth: 0,
                },
                backgroundColor: '#E5E7EB',
                fillerColor: 'rgba(91,15,115,0.4)',
                borderColor: 'transparent',
                moveHandleStyle: {
                    color: 'rgba(91,15,115,0.4)',
                },
                emphasis: {
                    moveHandleStyle: {
                        color: 'rgba(91,15,115,0.8)',
                    },
                },
            },
        ],
    };

    useEChart(chartDomRef, option);

    return <Box style={{ width: '100%', height: '100%' }}>{!isLoading && <Box ref={chartDomRef} style={{ width: '100%', height: '100%' }}></Box>}</Box>;
});

export default MeasureTrendLineChart;
